import React, { useCallback } from 'react';
import Check from '@/components/feature/icon/Check';
import Flexbox from '@/components/common/Flexbox';
interface MultiCheckboxProps<T = any> {
  options: Option<T>[];
  value?: T[];
  onChange: (value: T[] | undefined) => void;
  testIdPrefix?: string;
  noTopBorder?: boolean;
}
export const MultiCheckbox: React.FC<MultiCheckboxProps> = ({
  options,
  value = [],
  onChange,
  testIdPrefix = '',
  noTopBorder
}) => {
  const handleCheckboxChange = useCallback((v: string) => {
    const newValue = value.includes(v) ? value.filter(it => it !== v) // 如果存在就移除
    : [...value, v]; // 如果不存在就新增
    onChange(newValue);
  }, [value, onChange]);
  return <Flexbox direction={'column'} data-sentry-element="Flexbox" data-sentry-component="MultiCheckbox" data-sentry-source-file="MultiCheckbox.tsx">
      {!noTopBorder && <div className={'border-t border-grey5 w-full mb-3'} />}
      {options.map(option => <div key={option.key}>
          <Flexbox onClick={() => handleCheckboxChange(option.key)} align={'center'} data-test-id={`${testIdPrefix}multi-checkbox-option-${option.key}`} className={'space-x-2'}>
            <Check variant={'square'} checked={value.includes(option.key)} />
            <span>{option.label}</span>
          </Flexbox>
          <div className={'border-t border-grey5 w-full my-3'} />
        </div>)}
    </Flexbox>;
};